import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const DireccionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='DIRECCIÓN' htmlFor='select-direccion' md={2} />
      <Col md={10}>
        <Field name='direccion'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-direccion'
              placeholder='Ingresar dirección ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DireccionFormGroup)
